module.exports = __webpack_public_path__ + "static/img/1000000491_red.b7af2665.jpg";